/* tslint:disable:import-spacing no-trailing-whitespace no-inferrable-types */
import {
  Component,
  Input,
  OnInit,
  OnDestroy
}                   from '@angular/core';

import {Logger}     from "@/util/logger";

@Component({
  standalone: false,
  selector: 'admin-sidebar',
  template: `
    <mat-nav-list>
      <a mat-list-item [routerLink]="['/administration']" class="admin-sidenav-item">
        <span matLine>General</span>
      </a>
      <a mat-list-item [routerLink]="['/administration/users/pending']" class="admin-sidenav-item">
        <span matLine>Pending</span>
      </a>
      <a mat-list-item [routerLink]="['/administration/users']" class="admin-sidenav-item">
        <span matLine>Users</span>
      </a>
      <a mat-list-item [routerLink]="['/administration/sync']" class="admin-sidenav-item">
        <span matLine>Sync</span>
      </a>
      <a mat-list-item [routerLink]="['/administration/subdivisions']" class="admin-sidenav-item">
        <span matLine>Subdivisions</span>
      </a>
      <a mat-list-item [routerLink]="['/administration/projects']" class="admin-sidenav-item">
        <span matLine>Projects</span>
      </a>
      <a mat-list-item [routerLink]="['/administration/organizations']" class="admin-sidenav-item">
        <span matLine>Organizations</span>
      </a>
      <a mat-list-item [routerLink]="['/administration/users/new']" class="admin-sidenav-item">
        <span matLine>Add User</span>
      </a>
    </mat-nav-list>
  `
})
export class AdminSidebar implements OnInit, OnDestroy {

  /** how the template tells us which section of admin area we are in */
  @Input() section: string;

  /** the sub-title for the header */
  public title: string;

  /** initialize component */
  ngOnInit(): void {

    this.title = this.section;

    Logger.debug(`[AdminSidebar] setting up (${this.title})...`);

  }

  /** tear down component */
  ngOnDestroy(): void {

    Logger.debug(`[AdminSidebar] destroying (${this.title}).`);

  }

}
